import { Analytics, GTM, EventHub } from '@miro-site/analytics';
var analytics = new Analytics();

var getAnalytics = function getAnalytics() {
  if (!analytics.isPrepared) {
    var providers = [];

    if (process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID) {
      providers.push( // Init GTM
      new GTM(process.env.NEXT_PUBLIC_ANALYTICS_GTM_ID, process.env.NEXT_PUBLIC_ANALYTICS_GTM_AUTH || '', 'env-5', 'x', 'dataLayer', {}, {}));
    }

    if (process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT && process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH) {
      var eventHubUrl = process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_URL || '';
      providers.push(new EventHub(eventHubUrl, process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH, process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT));
    }

    analytics.prepare(providers);
  }

  return analytics;
};

export default getAnalytics;